import ApplicationAdapter from "./application";

export default class UserAdapter extends ApplicationAdapter {
  // customer/settings has no GET, so reads go through the same no-op POST as writes.
  findRecord(store, type, id, snapshot) {
    return this.ajax(this.urlForFindRecord(id, type.modelName, snapshot), "POST", { data: {} });
  }

  urlForFindRecord(id) {
    return `${this.apiBaseUri}/customer/settings?organizationnumber=${id}`;
  }

  urlForCreateRecord() {
    return `${this.apiBaseUri}/user/createorganization`;
  }

  urlForUpdateRecord(id) {
    return `${this.apiBaseUri}/customer/settings?organizationnumber=${id}`;
  }
}
